import React from 'react'
import { FaUserCheck, FaUserFriends, FaUserPlus } from 'react-icons/fa'
import { Circle } from '@mui/icons-material'
import { MVPDropdownLink } from '../../Link/MVPDropdownLink'
import ContextMenu from '../../ContextMenu/ContextMenu'
import FriendsModal from '../../modals/Friends/FriendsModal'
import FriendsFindModal from '../../modals/Friends/Find/FriendsFindModal'
import FriendsRequestsModal from '../../modals/Friends/Requests/FriendsRequestsModal'
import './FriendsMenu.scss'

interface Props
{
	showFriendsIndicator: boolean,
	showFriendsRequetsIndicator: boolean
}
export const FriendsMenu = ({ showFriendsIndicator, showFriendsRequetsIndicator } : Props) =>
{
	const clickFriendRequests = () => {
		FriendsRequestsModal.Show()
	}

	const clickFindFriends = () => {
		FriendsFindModal.Show()
	}

	const clickFriends = () => {
		FriendsModal.Show(true, false, true, true)
	}

	return (
		<ContextMenu id="friends-menu" alignment='center'>
			<MVPDropdownLink onClick={clickFriendRequests}>
				<FaUserCheck />
				&nbsp;&nbsp;FRIEND REQUESTS
				{showFriendsRequetsIndicator && <Circle className='indicator' color='error'/>}
			</MVPDropdownLink>
			<MVPDropdownLink onClick={clickFindFriends}>
				<FaUserPlus />
				&nbsp;&nbsp;FIND NEW FRIENDS
			</MVPDropdownLink>
			<MVPDropdownLink onClick={clickFriends}>
				<FaUserFriends />   
				&nbsp;&nbsp;FRIENDS
				{showFriendsIndicator && <Circle className='indicator' color='error'/>}
			</MVPDropdownLink>
		</ContextMenu>
	)
}
